import React from 'react'

import { useRequestDemoModal } from 'context/RequestDemoModalContext'

// Panel shown in place of pricing details / product details for a product
// flagged `comingSoon` in utils/constants/product.js.
function ComingSoon({ name, icon: Icon, description, className = "" }) {
    const { setRequestDemoModalOpen } = useRequestDemoModal()

    return (
        <div className={`w-full max-w-3xl bg-white text-black rounded-xl drop-shadow-xl p-6 md:p-10 flex flex-col sm:flex-row gap-4 sm:gap-8 items-start ${className}`}>
            {Icon && (
                <div className='shrink-0 flex items-center justify-center w-16 h-16 lg:w-20 lg:h-20 rounded-xl bg-maplexxon-purple-light'>
                    <Icon width='36' height='28' />
                </div>
            )}
            <div>
                <p className='text-xs lg:text-sm uppercase tracking-widest font-bold text-maplexxon-blue mb-2'>Coming soon</p>
                <p className='text-xl lg:text-3xl font-bold mb-2 lg:mb-4'>{name}</p>
                <p className='text-sm lg:text-base text-maplexxon-grey-2 mb-6'>
                    {description || "We are still building this product. It is not available yet, but you can talk to our team about it now."}
                </p>
                <button
                    onClick={() => setRequestDemoModalOpen(true)}
                    className='text-sm lg:text-base font-medium px-4 py-2 lg:px-6 lg:py-3 text-white rounded-md bg-maplexxon-blue'
                >
                    Request a demo
                </button>
            </div>
        </div>
    )
}

export default ComingSoon
